import { Maturity, Release } from '@upright/common/model/releases/types';
import ExclamationCircleIcon from '@upright/ui/common/generic/components/icons/hero-icons/hi-exclamation-circle.svg';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { KBUrl } from '@upright/ui/common/upright/kb-urls';
import styled from 'styled-components';
import { ExternalTextLinkWithIcon } from '../../../../links/external-text-link-with-icon';
import { TippyWithOriginalStyles } from '../../../../tooltips/default-tippy';

interface Props {
  releases: Release[];
  selectedRelease: Release | null | undefined;
}

export const ReleaseWarning = (props: Props) => {
  const { releases, selectedRelease } = props;
  const latestPublicRelease = findLatestPublicRelease(releases);

  if (selectedRelease === undefined) {
    return <></>;
  }
  if (selectedRelease === null) {
    return (
      <Root>
        <TippyWithOriginalStyles
          trigger={'mouseenter focus'}
          interactive={true}
          content={<span>No release is currently selected. Company and portfolio data will not be available.</span>}
          placement="bottom"
        >
          <div>
            <ExclamationCircleIcon />
          </div>
        </TippyWithOriginalStyles>
      </Root>
    );
  }
  if (selectedRelease.maturity === Maturity.STABLE) {
    return (
      <Root>
        <TippyWithOriginalStyles
          trigger={'mouseenter focus'}
          interactive={true}
          content={
            <span>
              Please note that you're currently viewing results from a stable release{' '}
              <strong>{selectedRelease.number}</strong> which does not reflect latest changes to data. The release
              incorporating latest data is <strong>{latestPublicRelease?.number ?? 'N/A'}</strong>. Read more about
              releases <KbLink />.
            </span>
          }
          placement="bottom"
        >
          <div>
            <ExclamationCircleIcon />
          </div>
        </TippyWithOriginalStyles>
      </Root>
    );
  }
  return <></>;
};

function findLatestPublicRelease(releases: Release[]) {
  return releases.find(r => r.maturity === Maturity.LATEST_PUBLIC);
}

const KbLink = () => {
  return <ExternalTextLinkWithIcon to={KBUrl.RELEASE_CYCLE} text={'here'} />;
};

const Root = styled.div`
  svg {
    height: 17px;
    margin-top: 4px;
  }
  /**
  ET note: hacky workaround to styles in src/ui/common/generic/components/bou-tool-header/desktop-header/items/index.tsx
   */
  * {
    &:hover,
    &:active {
      color: ${BouColor.TOOL_TEXT_WHITE} !important; // RN: even hackier addition. Seemed to be needed due to the above.
    }
  }
`;
